"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CredentialType = void 0;
var CredentialType;
(function (CredentialType) {
    CredentialType["ROBOTA"] = "robota";
    CredentialType["BOX"] = "box";
    CredentialType["AWS"] = "aws";
    CredentialType["CONCUR"] = "concur";
    CredentialType["SAML"] = "saml";
    CredentialType["PEPPOL"] = "peppol";
    CredentialType["COUPA"] = "coupa";
})(CredentialType = exports.CredentialType || (exports.CredentialType = {}));
